import { DownloadOutlined, SearchOutlined, DeleteOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useCallback, useState } from 'react'
import { orderService } from 'services'
import { toast } from 'react-toastify'
import { openInNewTab, createPreOpenedWindow } from 'helpers'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    position: relative;
    top: 1px;
  }

  button {
    height: 40px;
  }

  .wrap-button {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }
`

const ActionGroup = ({
  searchOrder,
  listSelectedOrder,
  loadingSearch,
  setListSelectedOrder,
}: {
  searchOrder: () => void
  listSelectedOrder: any[]
  setListSelectedOrder: (input: any) => void
  loadingSearch: boolean
}) => {
  const [loading, setLoading] = useState<boolean>(false)
  const handleCancel = useCallback(() => {
    if (listSelectedOrder?.length > 0) {
      setLoading(true)
      orderService.cancelByIds(
        listSelectedOrder?.map((item) => item?.id),
        (response) => {
          // toast.success(response?.data?.message, {
          //   autoClose: 1000,
          // })
          setLoading(false)
          setListSelectedOrder([])
          searchOrder()
        },
        (response) => {
          toast.error(response?.message)
          searchOrder()
          setLoading(false)
        }
      )
    }

  }, [listSelectedOrder, searchOrder, setListSelectedOrder])
  const printWaybill = useCallback(() => {
    if (listSelectedOrder?.length > 0) {
      if (listSelectedOrder.length == 1) {
        openInNewTab(`/in-don-hang?id=${listSelectedOrder[0]?.id}`)
        return
      }

      setLoading(true)
      const ids = listSelectedOrder?.map((item) => item?.id)

      // Pre-open a blank window to avoid popup blocking
      const newWindow = createPreOpenedWindow()

      orderService.createListOrderDownload(
        ids.join(','),
        (response) => {
          const url = `/in-don-hang?list_id=${response?.data?.list_id}`

          if (newWindow && !newWindow.closed) {
            // If popup window is still open, navigate to the URL
            newWindow.location.href = url
          } else {
            // Fallback: try to open in new tab (might be blocked)
            const opened = openInNewTab(url)
            if (!opened) {
              // If popup is blocked, download PDF directly
              toast.info('Popup bị chặn. Đang tải file PDF...', { autoClose: 2000 })
              orderService.downloadPdfDirectly(
                response?.data?.list_id,
                () => {
                  toast.success('Tải file thành công!', { autoClose: 2000 })
                },
                () => {
                  toast.error('Không thể tải file. Vui lòng thử lại.', { autoClose: 3000 })
                }
              )
            }
          }
          setLoading(false)
        },
        (response) => {
          // Close the pre-opened window if API fails
          if (newWindow && !newWindow.closed) {
            newWindow.close()
          }
          toast.error(response?.message)
          setLoading(false)
        }
      )
    }
  }, [listSelectedOrder])

  return (
    <Wrapper>
      <Button onClick={searchOrder} loading={loadingSearch} disabled={loadingSearch}>
        <SearchOutlined /> Tìm kiếm
      </Button>

      <div className='wrap-button'>
        <Button
          disabled={!listSelectedOrder?.length}
          onClick={() => printWaybill()}
        >
          <DownloadOutlined /> In đơn vận
        </Button>
        <Button onClick={handleCancel} loading={loading} disabled={!listSelectedOrder?.length}>
          <DeleteOutlined /> Hủy đơn vận
        </Button>
      </div>
    </Wrapper>
  )
}

export default ActionGroup
